export function ensureArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
